import { EntityType } from '../../../@types/entityTypes';
import instanceQuery from '../../queries/product/MaterialColourQuery.graphql';
import workspaceQuery from '../../queries/product/MaterialColourWorkspaceQuery.graphql';
import defaultQuery from '../../queries/product/MaterialColourDefault.graphql';
import mutationQuery from '../../mutations/product/MaterialColourMutation.graphql';
import fragment from '../../fragments/product/MaterialColourFragment.graphql';

const MaterialColour: EntityType = {
  type: 'MaterialColour',
  title: 'Material Colours',
  formTitle: 'Material Colour',
  formUrl: '/Products/EPR/MaterialColour/Details/',
  workspaceUrl: '/Products/EPR/MaterialColour/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment: fragment,
  dropdown: {
    query: workspaceQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  screenReference: 'MATERIAL_COLOUR',
};

export default MaterialColour;
